// Script para cargar procedimientos quirúrgicos en Firestore
// Ejecutar este script UNA VEZ para poblar la colección 'surgicalProcedures'

import { collection, addDoc, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { SURGICAL_PROCEDURES } from '../data/surgicalProcedures';

export const loadSurgicalProceduresToFirestore = async () => {
  try {
    console.log('Iniciando carga de procedimientos quirúrgicos...');
    
    // Verificar si ya existen procedimientos
    const proceduresRef = collection(db, 'surgicalProcedures');
    const snapshot = await getDocs(proceduresRef);
    
    if (snapshot.size > 0) {
      console.log(`Ya existen ${snapshot.size} procedimientos en la base de datos.`);
      const response = window.confirm(
        '¿Desea recargar los procedimientos? Esto no duplicará los existentes, solo agregará los nuevos.'
      );
      if (!response) {
        console.log('Carga cancelada por el usuario.');
        return;
      }
    }
    
    let added = 0;
    let skipped = 0;
    
    for (const procedure of SURGICAL_PROCEDURES) {
      // Verificar si el procedimiento ya existe por ID
      const existingProcedure = snapshot.docs.find(doc => doc.data().id === procedure.id);
      
      if (existingProcedure) {
        console.log(`Procedimiento ${procedure.id} ya existe, saltando...`);
        skipped++;
        continue;
      }
      
      // Agregar el procedimiento
      await addDoc(proceduresRef, {
        ...procedure,
        createdAt: new Date(),
        active: true
      });
      
      added++;
      console.log(`✓ Agregado: ${procedure.name} (${procedure.category})`);
    }
    
    console.log('\n=== RESUMEN ===');
    console.log(`Total de procedimientos en archivo: ${SURGICAL_PROCEDURES.length}`);
    console.log(`Procedimientos agregados: ${added}`);
    console.log(`Procedimientos existentes (saltados): ${skipped}`);
    console.log('¡Carga completada exitosamente!');
    
    return {
      success: true,
      added,
      skipped,
      total: SURGICAL_PROCEDURES.length
    };
    
  } catch (error) {
    console.error('Error al cargar procedimientos:', error);
    return {
      success: false,
      error: error.message
    };
  }
};
